import Layout from "../../../components/layout";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import { getCouponList } from "../../../apis/coupon";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import Switch from "@mui/material/Switch";
import Spinner from "../../../components/spinner";
import Errors from "../../errors";

import { useState } from "react";

import { Snackbar } from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import React from "react";

import { useTableSearch } from "../../../hooks/useTableSearch";
import useReadUpdated from "../../../hooks/updated/useRead";
import useCreate from "../../../hooks/useCreate";
import useRead from "../../../hooks/useRead";
import Pagination from "../../../components/elements/pagination";
import { useParams, useSearchParams } from "react-router-dom";
import AddCoupons from "../../customers/coupons/AddCoupons";
import EditCoupons from "../../customers/coupons/EditCoupons";
import DeleteCoupon from "../../customers/coupons/DeleteCoupon";
import AddPricing from "./AddPricing";
import EditPricing from "./EditPricing";
import Moment from "react-moment";
import { formatDate } from "../../../utilities";
import DeletePricing from "./DeletePricing";
import {
  handleDiscountStatus,
  handleUpdatePricingStatus,
} from "../../../apis/pricing";
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function Pricing() {
  const { id } = useParams(); // Extract the id from the URL
  const [outOfStockId, setOutOfStockId] = useState(0);
  // NEW: Track which priceId is being updated for daily_discount
  const [dailyDiscountId, setDailyDiscountId] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams();
  const initialState = {
    pageNo: searchParams.get("pageNo") || 0,
    limit: searchParams.get("limit") || 10,
    searchQuery: searchParams.get("searchQuery") || "",
    id: id,
  };
  // const limit = 1;
  const [couponState, setCouponState] = useState(initialState);
  const [currentPage, setCurrentPage] = useState(0);
  const [openAddModal, setOpenAddModal] = useState(false);
  const { data, paramsObject, setGetListParams } = useRead({
    method: "GET",
    url: "product/price/list",
    initialData: initialState,
  });

  const totalCount = data?.data?.total_count || 0;
  const totalPages = Math.ceil(totalCount / couponState.limit);
  const handleOpenAddCoupon = () => {
    setOpenAddModal(true);
  };
  const handleModalClose = () => {
    setOpenAddModal(false);
    setOpenDeleteModal(false);
    setIsOpenEditModal(false);
  };
  const [couponId, setCouponId] = useState(0);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const handleOpenDeleteModal = (id) => {
    setOpenDeleteModal(true);
    setCouponId(id);
  };
  const [isDeletedSuccess, setIsDeletedSuccess] = useState(false);
  const deletedSuccess = () => {
    handleModalClose();
    setIsDeletedSuccess(true);
  };

  const [editData, setEditData] = useState({});

  const [isOpenEditModal, setIsOpenEditModal] = useState(false);
  const handleOpenEditModal = (id) => {
    setIsOpenEditModal(true);
    if (data && data.data && data.data.data) {
      let editItem = data.data.data.find((x) => x.price_id === id);
      setEditData(editItem || {}); // Ensure `editItem` exists, otherwise set an empty object
    } else {
      console.error("Data is not yet available or is in an invalid format.");
    }
  };
  const handleSearchVal = (e) => {
    let value = e.target.value;
    let copyPrams = {
      ...paramsObject,
      searchQuery: value,
    };
    setSearchParams(copyPrams);
    setGetListParams(copyPrams);
    // setSearcVal(value)
  };
  const handleChangeOutOfStock = (e, priceId) => {
    setOutOfStockId(priceId); // So we can show a spinner in the correct row
    const outOfStock = e.target.checked; // Boolean from the switch

    // Send request to the server via the mutation
    changeOutOfStock.mutate({
      price_id: priceId,
      in_stock: outOfStock,
    });
  };
  const changeDailyDiscount = useMutation(handleDiscountStatus, {
    onSuccess: (res) => {
      if (res.status === 200) {
        queryClient.invalidateQueries("productlist");
      }
      setDailyDiscountId(0);
    },
    onError: (err) => {
      setDailyDiscountId(0);
      console.error(err);
    },
  });

  const handleChangeDailyDiscount = (e, priceId) => {
    setDailyDiscountId(priceId);
    changeDailyDiscount.mutate({
      price_id: priceId,
      daily_discount: e.target.checked,
    });
  };

  const queryClient = useQueryClient();

  const changeOutOfStock = useMutation(handleUpdatePricingStatus, {
    onSuccess: (res) => {
      if (res.status === 200) {
        // Invalidate or refetch the query to refresh your table data
        queryClient.invalidateQueries("productlist");
        setOutOfStockId(0); // Reset spinner id
      }
    },
    onError: (err) => {
      setOutOfStockId(0); // Stop spinner, handle error
      console.error(err);
    },
  });
  const handlePageClick = (val) => {
    let pageNo = {
      ...paramsObject,
      pageNo: val.selected,
    };
    setGetListParams(pageNo);
    setSearchParams(pageNo);
  };

  return (
    <>
      <div className="category px-4">
        <div className="category__head headingBorder__b">
          <h2 className="titleHeading">Pricing Details</h2>
        </div>
        <div className="category_table py-5 space-y-5">
          <div className="flex items-center space-x-4">
            <div className="flex-1">
              {/* <input
                onChange={handleSearchVal}
                type="text"
                placeholder="Search Coupons...."
                className="input"
              /> */}
            </div>
            <div onClick={handleOpenAddCoupon}>
              <Button
                variant="outlined"
                startIcon={<AddIcon />}
                className="primaryBtn-outlined"
              >
                Add Pricing
              </Button>
            </div>
          </div>
          {data?.isLoading ? (
            <Spinner />
          ) : data?.status === "error" ? (
            <Errors errorObject={data.error} inline />
          ) : (
            <div className="overflow-x-auto bg-white rounded-lg shadow overflow-y-auto relative">
              <table className="border-collapse table-auto w-full whitespace-no-wrap bg-white table-striped relative">
                <thead>
                  <tr className="text-left">
                    <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                      Sr.no
                    </th>
                    <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs text-center">
                      From Date
                    </th>
                    <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs text-center">
                      To Date
                    </th>
                    <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs text-center">
                      Units
                    </th>
                    <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs text-center">
                      Mrp Price
                    </th>
                    <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs text-center">
                      Selling Price
                    </th>
                    <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs text-center">
                      Business Selling Price
                    </th>
                    <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs text-center">
                      Stepper
                    </th>
                    <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs text-center">
                      Out of Stock
                    </th>
                    {/* <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs text-center">
                      Daily Discount
                    </th> */}
                    <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs text-center">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data?.data?.data?.map((couponData, idx) => {
                    const {
                      id,
                      price_id,
                      from_date,
                      to_date,
                      each_unit_value,
                      price_per_unit,
                      stepper,
                      mrp_price,
                      selling_price,
                      business_selling_price,
                      couponValidFrom,
                      in_stock,
                      couponValidTill,
                      status,
                    } = couponData;
                    return (
                      <tr key={price_id}>
                        <td className="border-dashed border-t border-gray-200 userId">
                          <span className="text-gray-700 px-6 py-3 flex items-center text-sm">
                            {idx + 1}
                          </span>
                        </td>
                        <td className="border-dashed border-t border-gray-200 firstName">
                          <span className="text-gray-700 px-6 py-3 block text-center text-sm">
                            {from_date
                              ? new Date(from_date * 1000).toLocaleDateString(
                                  // "en-US",
                                  {
                                    year: "numeric",
                                    month: "long",
                                    day: "numeric",
                                  }
                                )
                              : "N/A"}
                          </span>
                        </td>
                        <td className="border-dashed border-t border-gray-200 lastName">
                          <span className="text-gray-700 px-6 py-3 block text-center text-sm">
                            {to_date
                              ? new Date(to_date * 1000).toLocaleDateString(
                                  "en-US",
                                  {
                                    year: "numeric",
                                    month: "long",
                                    day: "numeric",
                                  }
                                )
                              : "--"}
                          </span>
                        </td>
                        <td className="border-dashed border-t border-gray-200 lastName">
                          <span className="text-gray-700 px-6 py-3 block text-center text-sm">
                            {each_unit_value} {price_per_unit}
                          </span>
                        </td>
                        <td className="border-dashed border-t border-gray-200 lastName">
                          <span className="text-gray-700 px-6 py-3 block text-center text-sm">
                            {mrp_price}
                          </span>
                        </td>
                        <td className="border-dashed border-t border-gray-200 lastName">
                          <span className="text-gray-700 px-6 py-3 block text-center text-sm">
                            {selling_price}
                          </span>
                        </td>
                        <td className="border-dashed border-t border-gray-200 lastName">
                          <span className="text-gray-700 px-6 py-3 block text-center text-sm">
                            {business_selling_price}
                          </span>
                        </td>
                        <td className="border-dashed border-t border-gray-200 emailAddress">
                          <span className="text-gray-700 px-6 py-3 block text-center text-sm">
                            {stepper}
                          </span>
                        </td>
                        <td className="border-dashed border-t border-gray-200 emailAddress">
                          <div className="flex items-center justify-center">
                            {price_id === outOfStockId ? (
                              <Spinner className="w-8 h-8" />
                            ) : (
                              <>
                                {/* <span className="text-gray-700 text-sm">In Stock</span> */}
                                <Switch
                                  inputProps={{ "aria-label": "controlled" }}
                                  onChange={(e) =>
                                    handleChangeOutOfStock(e, price_id)
                                  }
                                  checked={in_stock} // From your data
                                  className="hide_show_switch"
                                />
                                {/* <span className="text-gray-700 text-sm">Out of Stock</span> */}
                              </>
                            )}
                          </div>
                        </td>
                        {/* NEW: daily_discount column */}
                        {/* <td className="border-dashed border-t border-gray-200">
                          <div className="flex items-center justify-center">
                            {price_id === dailyDiscountId ? (
                              <Spinner className="w-8 h-8" />
                            ) : (
                              <Switch
                                onChange={(e) =>
                                  handleChangeDailyDiscount(e, price_id)
                                }
                                checked={couponData.daily_discount ?? false}
                              />
                            )}
                          </div>
                        </td> */}
                        <td className="border-dashed border-t border-gray-200 phoneNumber">
                          <div className="flex items-center space-x-1 justify-center">
                            <div>
                              <IconButton
                                onClick={() => handleOpenEditModal(price_id)}
                              >
                                <EditIcon />
                              </IconButton>
                            </div>
                            <div
                              onClick={() => handleOpenDeleteModal(price_id)}
                            >
                              <IconButton>
                                <DeleteIcon />
                              </IconButton>
                            </div>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
          <div className=" my-7">
            <Pagination
              currentPage={+paramsObject.pageNo}
              lengthofItems={data?.data?.total_count}
              limit={paramsObject.limit}
              onPageChange={handlePageClick}
            />
          </div>
        </div>
      </div>
      <AddPricing open={openAddModal} handleClose={handleModalClose} />
      <EditPricing
        open={isOpenEditModal}
        handleClose={handleModalClose}
        editData={editData}
      />
      <DeletePricing
        open={openDeleteModal}
        onClose={handleModalClose}
        price_id={couponId}
        onDelete={deletedSuccess}
      />
      {/* <Snackbar open={isDeletedSuccess} autoHideDuration={4000} onClose={() => setIsDeletedSuccess(false)}>
                <Alert onClose={() => setIsDeletedSuccess(false)} severity="success" sx={{ width: '100%' }}>
                    Category Deleted Succesfully
                </Alert>
            </Snackbar> */}
    </>
  );
}

export default Pricing;
